/** */
export const STATUS_LABELS = {
  queued: 'Queued',
  generating: 'Generating',
  completed: 'Completed',
  failed: 'Failed'
};

export const PENDING_STATUSES = ['queued', 'generating'];

export const WORD_MODES = { generated: 'generated', user: 'user' };

export const WORD_SOURCE_LABELS = { generated: 'AI words', user: 'Own words' };

export const MIN_WORD_COUNT = 4;
export const MAX_WORD_COUNT = 30;
export const DEFAULT_WORD_COUNT = 10;
export const MIN_GRID_SIZE = 8;
export const MAX_GRID_SIZE = 20;
export const MIN_WORD_LENGTH = 3;
export const DEFAULT_BORDER_COLOR = '#000000';
export const BORDER_COLOR_PATTERN = /^(#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})|[a-z]{3,20})$/i;

const DIRECTION_STEPS = {
  right: [0, 1],
  left: [0, -1],
  down: [1, 0],
  up: [-1, 0],
  down_right: [1, 1],
  down_left: [1, -1],
  up_right: [-1, 1],
  up_left: [-1, -1]
};

export const maxWordsForGrid = (grid_size) => Math.floor((grid_size * grid_size) / 8);

export const resolvePlacementCells = ({ word = '', row, col, direction }) => {
  const [d_row, d_col] = DIRECTION_STEPS[direction] || [0, 0];
  return Array.from(word).map((_, index) => `${row + d_row * index}:${col + d_col * index}`);
};

const reverseWord = (word) => Array.from(word).reverse().join('');

export const parseWordList = (text = '') =>
  text
    .split(/[\n,]/)
    .map((word) => word.trim())
    .filter(Boolean);

export const checkWords = (raw_words = [], max_length = MAX_GRID_SIZE) => {
  const seen = new Set();
  const cleaned = [];
  const rejected = [];

  raw_words.forEach((original) => {
    const word = original.toUpperCase().replace(/[^A-Z]/g, '');
    if (seen.has(word)) return;

    if (word.length < MIN_WORD_LENGTH) {
      rejected.push({ word: original, reason: `shorter than ${MIN_WORD_LENGTH} letters` });
    } else if (word.length > max_length) {
      rejected.push({ word: original, reason: `longer than ${max_length} letters` });
    } else if (word === reverseWord(word)) {
      rejected.push({ word: original, reason: 'palindrome' });
    } else {
      seen.add(word);
      cleaned.push({ word, original });
    }
  });

  const words = [];
  cleaned.forEach(({ word, original }) => {
    const host = cleaned.find(
      ({ word: other }) =>
        other.length > word.length && (other.includes(word) || other.includes(reverseWord(word)))
    );
    if (host) rejected.push({ word: original, reason: `hidden inside ${host.word}` });
    else words.push(word);
  });

  return { words, rejected };
};

export const resolveWordSearchTitle = ({ theme, input_words = [], words = [] } = {}) => {
  if (theme) return theme;
  const source_words = input_words.length ? input_words : words;
  if (!source_words.length) return 'Untitled word search';
  const preview = source_words.slice(0, 3).join(', ');
  return source_words.length > 3 ? `${preview}, …` : preview;
};
